import IndexStore from 'src/stores/index';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {isMobileDevice} from 'src/utils/responsive';
import isValidBrowser from 'src/webapp.browserslist.json';
import FluxComponent from 'src/flux/component';
import Notification from 'src/components/navigation/notification';

import css from './bad-browser-notification.css';

// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type.
const mapper = ({store}) => ({
  userAgent: store.requestHeaders.state.headers['user-agent'],
});

type Props = {
  store: IndexStore;
  userAgent: string;
};

const BadBrowserNotification = ({store, userAgent}: Props) => {
  const {t} = useLabelTranslation();
  // @ts-expect-error - TS2349 - This expression is not callable.
  if (!isValidBrowser(userAgent) || isMobileDevice(userAgent)) {
    return (
      <Notification store={store} className={css.wrapper}>
        <strong>{`${t(
          'You\'re_using_an_unsupported_browser',
          'You\'re using an unsupported browser',
        )}.`}</strong>
        <span>
          {`${t(
            'For_the_best_experience_on_Sense_please_be_sure_you\'re_on_a_desktop_not_a_tablet_or_phone_using_the_latest_versions_of_Chrome_Firefox_Safari_or_Microsoft_Edge',
            'For the best experience on Sense, please be sure you\'re on a desktop (not a tablet or phone), using the latest versions of Chrome, Firefox, Safari, or Microsoft Edge',
          )}.`}
        </span>
      </Notification>
    );
  } else {
    return null;
  }
};

const isKnownBadBrowser = (
  userAgent: string,
): boolean => // Mobile browsers are not supported
  /Mobi/.test(userAgent) ||
  // IE<11 not supported
  /MSIE/.test(userAgent) ||
  // IE11 not supported
  /Trident\/7\./.test(userAgent);

// @ts-expect-error - TS2345 - Argument of type '({ store, userAgent }: Props) => React.JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<{ store: any; }, any>'.
export default FluxComponent(BadBrowserNotification, mapper, {
  pure: true,
}) as React.ComponentType<Record<any, any>>;
